module.exports = __webpack_public_path__ + "static/media/greencircle.f4a293d7.svg";